import PlacesSummary from './Places';

export default PlacesSummary;
